import React from 'react';
import { styled } from '@compiled/react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { AIHeaderImageStatus, GenerateImageProps } from '@atlassian/ai-image-generation/types';
import type { FullPageEditorPresetAPI } from '@confluence/editor-presets/entry-points/useFullPageEditorPreset.ts';
import type { TitleAreaContentComponentsProps } from '../src/titleareaContentComponentsTypes.ts';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyTitleArea = styled.div<{ isTemplateEditor?: boolean }>({
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: (props) => (props.isTemplateEditor ? '87px' : '113px'),
});

export const TitleAreaContentComponents: LoadableType<TitleAreaContentComponentsProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-TitleAreaContentComponents" */ '../src/TitleAreaContentComponents.tsx'
				)
			).TitleAreaContentComponents,
		loading: (props) => <EmptyTitleArea isTemplateEditor={props.isTemplateEditor} />,
	});

export const SmartCreateTitleAreaContentComponents: LoadableType<{
	title: string | null;
	customTitlePlaceholder?: string;
	contentId: string;
	contentType: 'page' | null;
	isDisabled: boolean;
	onTitleChange: (value: string) => void;
	focusEditor: () => void;
	onFocusChanged: (focusChanged: boolean) => void;
	editorApi?: FullPageEditorPresetAPI;
	aiHeaderImageStatus?: AIHeaderImageStatus;
	aiHeaderImageFileId?: string;
	aiHeaderImageError?: string | null;
	generateAIHeaderImage?: (props: GenerateImageProps) => Promise<string | undefined>;
	setAIHeaderImageStatus?: (status: AIHeaderImageStatus) => void;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartCreateTitleAreaContentComponents" */ '../src/SmartCreateTitleAreaContentComponents.tsx'
			)
		).SmartCreateTitleAreaContentComponents,
	loading: () => <EmptyTitleArea />,
});
